export const MAX_ACCORDION = 6;
export const MAX_LOADER = 10;
export const BASE_SIGNPOST_CARD_HEIGHT = 160;
export const MOBILE_MAX_PREVIEW_LIMIT = 3;
export const TABLET_MAX_PREVIEW_LIMIT = 6;
export const DESKTOP_MAX_PREVIEW_LIMIT = 3;
export const CHARACTERS_PER_LINE = 30;

export const getLoadOption = (section: Queries.SectionDataFragment) => {
	if (section.promotedLinks.length <= 6) return "all";
	if (section.promotedLinks.length <= 12) return "accordion";
	return "loader";
};

export const checkIsFlat = (total: number, index: number) => {
	if (total % 2 === 0) return false; // There is an even number of cards so all are square
	if (index % 2 === 0) return false; // There is two or more and this is an even number so cannot be orphan card

	if (index === 1 && total === 1) return true; // There is one card so it should be flat.
	if (index === total) return true; // There is an odd number of cards and this is the last one so it should be flat.

	return false;
};
export const getBiggestCardTextCount = (
	items: DogsTrust.SignPostCardProps[],
) => {
	const biggestCard = items
		.filter((_item, i) => !checkIsFlat(items.length, i + 1))
		.map((item) => {
			return item.title.length + (item.body?.length || 0);
		});
	return biggestCard.reduce((a, b) => Math.max(a, b), 0);
};
